// extracted by mini-css-extract-plugin
export var table = "_ur-0";